/**
 * Resolves title card images to bundler-managed URLs.
 *
 * Title card images live in `src/assets/titles/` as `title1.png`, `title2.png`,
 * etc. The profile cosmetics catalog stores the numeric file id so selected
 * titles can render everywhere through the same `title.bg` field.
 */
const FILES = import.meta.glob('../../assets/titles/*.{png,jpg,jpeg,webp}', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

export function titleAssetUrl(file: number): string {
  const entry = Object.entries(FILES).find(
    ([path]) => /[/\\]title\d+\./.test(path) && path.includes(`title${file}.`),
  );
  return entry?.[1] ?? '';
}
